<!--
 * @Auther: 罗耀祖
 * @Date: 2021-07-07 18:53:40
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2021-07-07 19:16:51
 * @name: 琴行管理模块路由
 * @Description: 琴行管理模块路由
 * @FilePath: \backstage\src\views\pianoCompanyManage\pianoCompanyManageRouter.vue
 * @Author: DESKTOP-1QU67QM
-->
<template>
  <keep-alive :include="cashRouters">
    <router-view></router-view>
  </keep-alive>
</template>

<script>
export default {
  name: "pianoCompanyManageRouter",
  computed: {
    cashRouters() {
      return this.$store.state.cashView.cashRouters;
    },
  },
};
</script>